export default function intersectionObserverPolyfill(document: Document, window: Window): Promise<any> {
    if ("IntersectionObserver" in window) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        // tslint:disable-next-line:no-console
        console.debug("Polyfill: Polyfilling Intersection Observer...");
        (require as any).ensure(["intersection-observer"], (require: any) => {
            require("intersection-observer");
            resolve();
        });
    });
}



// WEBPACK FOOTER //
// ./polyfill/intersection-observer/intersection-observer.polyfill.ts